import { render, staticRenderFns } from "./passo4.vue?vue&type=template&id=5e553499&scoped=true&"
import script from "./passo4.vue?vue&type=script&lang=js&"
export * from "./passo4.vue?vue&type=script&lang=js&"
import style0 from "./passo4.vue?vue&type=style&index=0&id=5e553499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e553499",
  null
  
)

export default component.exports